var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScroll,
      expression: "onScroll"
    }],
    staticClass: "scroll-top scroll-top-full-page",
    attrs: {
      "href": "#Main",
      "fab": "",
      "fixed": "",
      "x-small": "",
      "bottom": "",
      "right": "",
      "color": "white",
      "transition": "slide-x-transition"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold font-size-12 font-size-lg-14 text-center color-grey-3"
  }, [_vm._v(" Top ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }